"use client";

import { SideMenu } from "@layout/SideMenu/SideMenu";
import { Box } from "@mui/material";
import { SideMenuProvider } from "@shared/contexts/SideMenuContext";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * ページ全体のレイアウトを提供するコンポーネント
 */
export const PageLayout = ({ children }: Props) => {
  return (
    <SideMenuProvider>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <SideMenu />
        {/* コンテンツエリア */}
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            marginLeft: "auto",
            overflow: "hidden",
            height: "100%",
            backgroundColor: "#f5f5f5",
          }}
        >
          {children}
        </Box>
      </Box>
    </SideMenuProvider>
  );
};
